export default {
    name: 'nds',
    data: () => ({
        nds: {
            value: null
        }
    }),
    methods: {
        async update_nds() {
            this.loading_nds_settings = true;
            this.$communicator.then(this, await this.$communicator('update_nds', {params: this.nds}))
            this.$toast.success("Success", {timeout: 2000});
            this.loading_nds_settings = false;
            this.get_nds()
        },
        async get_nds() {
            const res = this.$communicator.then(this, await this.$communicator('get_nds'))

            if (res && res.nds) {
                this.nds = res.nds
            }
        }
    },
    mounted() {
        this.get_nds()
    }
}
